export default __webpack_public_path__ + "static/media/frown-silver.02638a8d.svg";